import React, { Component } from 'react'
import PropTypes from 'prop-types'
// import { Link, graphql, useStaticQuery } from 'gatsby'
import styled from 'styled-components'
import 'react-dropdown/style.css'
import { colors, device } from '../../styles/config'
import Checkbox from './Checkbox'

const Container = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${ Checkbox } {
    @media ${ device.sm } {
      flex-basis: 50%;
      display: flex;

      &:nth-child(2) {
        position: relative;
        left: -1px;
      }

      &:nth-child(2),
      &:nth-child(4) {
        justify-content: flex-end;
      }
    }
  }
`

const FormRooms = ({
  roomAvailability,
  inselgarten,
  sonnendeck,
  brueckendeck,
  theaterdeck,
  onChange
}) => {
  return (
    <Container>
      <Checkbox>
        <input
          type="checkbox"
          checked={inselgarten}
          name="Inselgarten"
          id="form-room-inselgarten"
          disabled={roomAvailability.inselgarten}
          onChange={onChange}
        />
        <label htmlFor="form-room-inselgarten">Wiese</label>
      </Checkbox>
      <Checkbox>
        <input
          type="checkbox"
          checked={sonnendeck}
          name="Sonnendeck"
          id="form-room-sonnendeck"
          disabled={roomAvailability.sonnendeck}
          onChange={onChange}
        />
        <label htmlFor="form-room-sonnendeck">Sonnendeck</label>
      </Checkbox>
      <Checkbox>
        <input
          type="checkbox"
          checked={brueckendeck}
          name="Brueckendeck"
          id="form-room-brueckendeck"
          disabled={roomAvailability.brueckendeck}
          onChange={onChange}
        />
        <label htmlFor="form-room-brueckendeck">Brückendeck</label>
      </Checkbox>
      <Checkbox>
        <input
          type="checkbox"
          checked={theaterdeck}
          name="Theaterdeck"
          id="form-room-theaterdeck"
          disabled={roomAvailability.theaterdeck}
          onChange={onChange}
        />
        <label htmlFor="form-room-theaterdeck">Theaterdeck</label>
      </Checkbox>
    </Container>
  )
}

export default FormRooms
